import * as React from "react";
import PlayfulBounce from "../PlayfulBounce/PlayfulBounce";
import "./ComponentOnlyLoader.sass";

interface Props {
  loading: boolean;
  children?: any;
}

export const ComponentOnlyLoader = (props: Props) => {
  const { loading, children } = props;
  return (
    <div className="component-only-loader-wrapper">
      {loading && (
        <>
          <div className="component-loader-contents">
            <PlayfulBounce loading={true} />
          </div>
          <div className="component-loader-overlay"></div>
        </>
      )}
      {children}
    </div>
  );
};
